import {BlogCardAnimation} from "./components/blog-card";
import URLS from "../../../API/Axios/URLS";
import useListApi from "../../../hooks/useListApi";
import {getUri} from "../../../utils/utils";
import {useNavigate} from "react-router-dom";
import BlogCardNew from "./components/blog-card-new";
import PrimaryButton from "../../../components/Buttons/primary-button";

export default function BlogSection({className, ...props}) {
    let [blogData, filter, isDataLoading, blogActions] = useListApi(URLS.blogsList, {
        page_size: 6,
        query: "",
    });
    const navigate = useNavigate();
    return (
        <div
            className="px-[12px] bg-white lg:py-[140px] flex justify-center items-center box-border py-[18px] lg:px-[148px]">
            <div className={"flex w-full justify-center items-center flex-col"}>
                <div className={"flex flex-row gap-2 justify-center items-center"}>
                    <p className={"text-[24px] lg:text-[48px] pb-8 leading-[120%] lg:leading-[120%] text-center font-semibold"}>
                        Latest News & <span className={"text-tertiary-900"}>Blogs</span>
                    </p>
                    <img
                        src={"/images/blog-bird.svg"}
                        alt={"blog-bird"}
                        className="w-auto h-12 lg:h-16 object-contain"
                    />
                </div>


                <div
                    className={"grid grid-cols-1 mt-8 gap-[20px] lg:gap-[50px]  md:grid-cols-2 xl:grid-cols-3 w-full"}>
                    {isDataLoading && <>
                        {
                            Array(6).fill(0).map((_, index) => (
                                <BlogCardAnimation key={index} className={"w-full"}/>
                            ))
                        }
                    </>
                    }
                    {
                        blogData?.results?.map((item, index) => {
                            return <BlogCardNew
                                key={index}
                                title={item?.title}
                                metaDescription={item.meta_description}
                                date={item?.updated_at}
                                thumbnail={getUri(item.thumbnail?.file)}
                            />
                        })
                    }

                </div>

                <PrimaryButton
                    className={"mt-[48px]"}
                    onClick={() => {
                        navigate("/blogs")
                    }}
                 >
                    See all blogs
                </PrimaryButton>
            </div>
        </div>

    )
}